import React, {useState} from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import PetitionsCoordinatorView from "./PetitionsCoordinatorView";
// import ExamsCoordExtraordinaryExamsView from "./ExamsCoordExtraordinaryExamsView";
// import ExamsCoordExtraordinaryPetitionView from "./ExamsCoordExtraordinaryPetitionView";

const ExamsCoordView = () => {

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        console.log(`Going to tab ${newValue}`);
        setTabValue(newValue);
    };

    function TabPanel(props) {
        return(
            <div role="tabpanel"
                 hidden={tabValue !== props.index}
                 id={`tabpanel-${props.index}`}
                 aria-labelledby={`full-width-tab-${props.index}`}>
                { tabValue === props.index && (
                    <Box>
                        {props.component}
                    </Box>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <AppBar position={"static"}>
                <Tabs variant={"fullWidth"} value={tabValue} onChange={handleTabChange}>
                    <Tab label={"Peticiones Realizadas"} />
                    {/* <Tab label={"Examenes extraordinarios"} />
                    <Tab label={"Peticiones fuera de plazo"} /> */}
                </Tabs>
            </AppBar>
            <TabPanel index={0} component={PetitionsCoordinatorView}/>
            {/* <TabPanel index={1} component={ExamsCoordExtraordinaryExamsView}/>
            <TabPanel index={2} component={ExamsCoordExtraordinaryPetitionView}/> */}
        </React.Fragment>
    )
}

export default ExamsCoordView